import { lazy } from "react";
const Home = lazy(() => {
  return import("containers/home");
});
const Assets = lazy(() => {
  return import("containers/assets");
});
const Profile = lazy(() => {
  return import("containers/profile");
});
const Fund = lazy(() => {
  return import("containers/fund");
});
const BankHome = lazy(() => {
  return import("containers/bankHome");
});

const routes = [
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/assets",
    element: <Assets />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/funds",
    element: <Fund />,
  },
  { path: "/card", element: <BankHome /> },
];

export default routes;
